import * as actions from '@actions';
import { useDispatch } from 'react-redux';
import { useQueryClient, useSuspenseQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useSessionAppointment } from '@hooks/useSessionAppointment';

export function useAppointmentDetails(current_appt_id: number) {
  const dispatch = useDispatch();
  const { appointment } = useSessionAppointment();
  const queryClient = useQueryClient();

  const queryKey = ['appointmentDetails', current_appt_id, appointment.appointment_completed] as const;

  const {
    data: { appts } = { appts: [] },
    refetch,
    status,
    isLoading
  } = useSuspenseQuery({
    queryKey,
    queryFn: () => dispatch(actions.getAppointmentDetails(current_appt_id)),
    refetchOnWindowFocus: false,
    staleTime: Infinity
  });
  const detailsCurrentAppointment = appts?.find((appt) => appt?.appt_id && `${appt?.appt_id}` === `${current_appt_id}`);
  const detailsPastCompletedAppointments = appts?.filter(
    (appt) => appt?.appt_completed_date && `${appt?.appt_id}` !== `${current_appt_id}`
  );

  return {
    detailsAllAppointments: appts,
    detailsCurrentAppointment,
    detailsPastCompletedAppointments,
    refetch,
    status,
    isLoading,
    invalidate: useCallback(() => queryClient.invalidateQueries({ queryKey }), [])
  };
}

export default useAppointmentDetails;
